// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PgB_p","content":"styles_content__1gfOp"};